<mat-slide-toggle
  [checked]="value()"
  [disabled]="isDisabled() || disabled()"
  [color]="color()"
  [labelPosition]="labelPosition()"
  (change)="onToggleChange($event)"
>
  <ng-content></ng-content>
</mat-slide-toggle>
